import React from "react";

const ImageChecked = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		width="14"
		height="14"
		viewBox="0 0 14 14"
	>
		<path d="M0 10V7l4 4L15 0v3L4 14z" />
	</svg>
);

export default ImageChecked;
